<template>
  <div>
    <DetailRow
      label="LOR Reporting Year"
      :value="landownerReport.reportingYear"
    />
    <DetailRow
      label="Town, Township, or Plantation"
      :value="getTownName(notification.townGeocodeNum)"
    />
    <DetailRow
      label="County"
      :value="getTownProperty(notification.townGeocodeNum, 'countyName')"
    />
    <hr class="border-dark">
    <h5>
      Landowner Contact
    </h5>
    <ContactDetails
      :contact="notification.landownerContact
        || notification.landownerUser"
      :disableRemove="true"
    />
    <hr class="border-dark">
    <ul class="mb-0">
      <li class="mb-2">
        This property <strong>WAS {{landownerReport.harvest ? '' : 'NOT '}}</strong>
        harvested during this year.
      </li>
      <li v-if="landownerReport.harvestComplete !== null" class="mb-2">
        This harvest <strong>WAS {{landownerReport.harvestComplete ? '' : 'NOT '}}</strong>
        completed this year.
      </li>
      <li class="mb-2">
        There <strong>WERE {{landownerReport.nonHarvest ? '' : 'NO '}}</strong>
        non-harvest activities during this reporting year.
      </li>
    </ul>
    <DetailRow
      v-if="landownerReport.harvest"
      label="Method of Payment or Type of Sale"
      :value="getSaleTypeName(landownerReport.saleTypeId) || 'None'"
    />
    <b-alert v-if="landownerReport.editorCommentGeneralDetails" variant="warning" show class="mt-3">
      <strong>Editor's Comment:</strong>
      <p class="mb-0 mt-1">{{ landownerReport.editorCommentGeneralDetails }}</p>
    </b-alert>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import ContactDetails from '@/components/account/ContactDetails.vue';
import DetailRow from '@/components/DetailRow.vue';
import LookupModules from '@/store/moduleConfig';

export default {
  name: 'GeneralDetails',
  components: {
    ContactDetails,
    DetailRow,
  },
  created() {
    this.$store.dispatch(`${LookupModules.SALE_TYPES.namespace}/fetchOptions`);
    this.$store.dispatch(`${LookupModules.TOWNS.namespace}/fetchOptions`);
  },
  computed: {
    ...mapState('Notification', {
      notification: state => state.notification,
    }),
    ...mapState('LandownerReport', {
      landownerReport: state => state.landownerReport,
    }),
    ...mapGetters(LookupModules.SALE_TYPES.namespace, {
      getSaleTypeName: 'getName',
    }),
    ...mapGetters(LookupModules.TOWNS.namespace, {
      getTownName: 'getName',
      getTownProperty: 'getProperty',
    }),
  },
};
</script>
